exports.init = function() {
  const buttons = document.getElementsByClassName('panel-button-dropdown');
  const panelMenu = document.getElementById('panel-menu');

  if (buttons.length && panelMenu) {
    [].forEach.call(buttons, function(button) {
      button.addEventListener('click', function() {
        panelMenu.classList.toggle('is-active');
      });
    });
  }

};
